export default __webpack_public_path__ + "static/media/logoNewLight.bc056ea7.svg";